import React from 'react';

import { CTA } from '@volkswagen-onehub/components-core';
import GoBack from '../icons/GoBack';

import { GoBackContainer } from './styles';
import { useHistory } from '../../hooks/use-history';
import { useMyVwContext } from '../../hooks/use-my-vw-context';

const GoBackComponent = () => {
  const { translationHandler } = useMyVwContext();
  const history = useHistory();

  return (
    <GoBackContainer
      onClick={() => {
        history.push('/');
      }}
    >
      <CTA tag="a" emphasis="tertiary" icon={<GoBack iconSize={24} />}>
        {translationHandler('goBack')}
      </CTA>
    </GoBackContainer>
  );
};

export default GoBackComponent;
